module.exports = __webpack_public_path__ + "images/bx_loader.gif";